/**
 * 邮箱变更
 */
<template>
  <div class="userbox ">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/personal/user' }">账号信息</el-breadcrumb-item>
      <el-breadcrumb-item>设置邮箱</el-breadcrumb-item>
    </el-breadcrumb>

    <div>
      <el-card class="box-card">
        <div class="box-card-content">
          <el-steps :active="active" finish-status="success">
            <el-step title="验证身份">
            </el-step>
            <el-step title="设置邮箱"></el-step>
            <el-step title="完成"></el-step>
          </el-steps>

          <div>
            <div v-show="index1" style="margin-left: 20%;margin-top:100px">
              <h5>手机验证码验证：为确认你本人操作，请完成以下验证</h5>
              <p>手机号码： {{$store.state.user.mobile}}</p>
              <div>
                <el-input v-model="captcha" placeholder="短信验证码" style="width: 200px"></el-input>
                <el-button type="danger" v-show="smsshow" style="width: 120px" @click="sendSMS1">获取验证码</el-button>
                <el-button type="info" v-show="!smsshow" style="width: 120px">已发送({{count}}s)</el-button>
                <p style="font-size:12px" v-show="!smsshow"> <i class="el-icon-success" style="color:#67c23a;"></i> <span style="color:#999">验证码已发送到你的手机，3分钟内输入有效，验证码等同于密码，打死也不能告诉别人</span> </p>
              </div>
            </div>
            <div v-show="index2" style="margin-left: 20%;margin-top:80px">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

                <p style="font-size:14px;padding-bottom:20px"> <i class="el-icon-warning" style="color:#e6a23c;font-size:16px"></i> <span>请确保您输入的邮箱能正常接收激活邮件，邮箱才能生效。</span> </p>
                <el-form-item label="新邮箱" prop="email">
                  <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="captcha">
                  <el-input v-model="ruleForm.captcha" placeholder="" style="width: 140px"></el-input>
                  <el-button type="danger" v-show="smsshow2" style="width: 120px" @click="sendSMS2">获取验证码</el-button>
                  <el-button type="info" v-show="!smsshow2" style="width: 120px">{{count}} s</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-show="index3">
              <el-result icon="success" title="邮箱设置成功" subTitle="">
                <template slot="extra">
                  <!-- <el-button class="next-button" size="medium">重新登录系统</el-button> -->
                </template>
              </el-result>
            </div>
          </div>
          <div style="text-align: center;" v-show="!index3">
            <el-button class="next-button" @click="next">下一步</el-button>
          </div>

          <div style="text-align: center;" v-show="index3">
            <el-button class="next-button" @click="closeFun">关闭</el-button>
          </div>
        </div>

      </el-card>

    </div>
  </div>
</template>

<script>
//API
import {changemobilesms1,changemobileveriry1,sendemailcapatch,changeemail} from '../../api/userMG'

export default {
  data() {
    
    let checkEmail = (rule, value, callback) => {
        let reg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的邮箱'))
        } else {
          callback()
        }
    }
    return {
      captcha: '',
      disabled: false,
      active: 0,
      timer: null,
      smsshow: true,
      smsshow2: true,
      count: '',
      index1: true,
      index2: false,
      index3: false,
      ruleForm: {
        email: '',
        captcha: ''
      },
      rules: {
        email: [{ required: true, message: '邮箱输入不正确', trigger: 'blur' },
          { validator: checkEmail, message: '请输入正确的邮箱', trigger: 'blur'}],
        captcha: [{ required: true, message: '验证码错误', trigger: 'blur' }]
      }
    }
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    next() {
      // if (this.active++ > 2) this.active = 0

      switch (this.active) {
        // case 0:
        //   this.index1 = true
        //   this.index2 = !this.index1
        //   this.index3 = !this.index1
        //   break
        case 0:
          this.verifyCode1()
          break
        case 1:
          this.verifyCode2()
          break
      }
    },
    sendSMS1() {
      const params = {}
      changemobilesms1(params).then(resp => {
        if(resp.code==0){
          this.$message.success('发送成功')
          //倒计时
          this.setTimer(1)
        }else{
          if(resp.code==1001 || resp.code==1002 ){
            this.$message.warning(`请勿频繁发送验证码`)
          }
        }
      }, err => {
        this.$message.error('短信发送失败')
      })
        
      
    },
    sendSMS2() {
      const params = {
        sessionid: this.$cookies.get('X-session-id'),
        email: this.ruleForm.email
      }
      sendemailcapatch(params).then(resp => {
        if(resp.code==0){
          this.$message.success('发送成功')
          //倒计时
          const TIME_COUNT = 60
          this.setTimer(2)
        }else{
          if(resp.code==1001||resp.code==1002){
            this.$message.warning(`请勿频繁发送验证码`)
          }
        }
      }, err => {
        this.$message.error('邮件发送失败')
      })
        
      
    },
    setTimer(index){
      //倒计时
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        if(index==1){
          this.smsshow = false
        }else if(index==2){
          this.smsshow2 = false
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            if(index==1){
              this.smsshow = true
            }else if(index==2){
              this.smsshow2 = true
            }
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    verifyCode1(){
      const  params = {
        captcha: this.captcha
      }
      changemobileveriry1(params).then(resp => {
        if(resp.code==0){
          clearInterval(this.timer)
          this.smsshow = true
          this.captcha = ''
          this.index2 = true
          this.index1 = !this.index2
          this.index3 = !this.index2
          this.active++ 
          this.timer = null
        }else{
          this.$message.error(resp.message)
        }
      })
    },
    verifyCode2(){
      const  params = {
        captcha: this.ruleForm.captcha,
        email: this.ruleForm.email
      }
      changeemail(params).then(resp => {
        if(resp.code==0){
          this.smsshow = true
          this.index3 = true
          this.index2 = !this.index3
          this.index1 = !this.index3
          this.timer = null
          this.active++ 
        }else{
          this.$message.error(resp.message)
        }
      })
    },
    closeFun(){
      this.$router.push({ path: '/personal/user' })
    }
  }
}
</script>

<style scoped>
.box-card {
  /* width: 100%; */
  margin-top: 20px;
}
.box-card-content {
  width: 80%;
  margin-left: 10%;
}
.next-button {
  margin-top: 80px;
  background-color: rgb(211, 110, 105);
  color: rgb(255, 255, 255);
}
</style>

<style >
.el-step__head.is-process .el-step__icon {
  background-color: #d36e69;
  /* color: #fff; */
  /* border-color: tomato; */
}
.el-step__head.is-process {
  color: #fff;
  border-color: #d36e69;
}
.el-step__line {
  margin-right: 5px !important;
  margin-left: 30px;
}
.el-step__title.is-process {
  color: #d36e69;
}
.userbox .el-form .el-input {
  width: 270px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/personal/emailchange.vue